
/**
 * DynamicScriptLoader Class
 * 
 * Loads scripts dynamically
 * 
 * 
 * @class DynamicScriptLoader
 * @constructor
 * @requires moolite 1.0.3+, AjaxManager
 * @type Class
 * 
 */

//TODO: Resolve issue with no initial load and false condition on load, example loading ie or mobile on a mac desktop

var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Functions = OCS.Functions || {};

OCS.Classes.DynamicScriptLoader = new Class({
    Implements: [Options],
    options: {
        job_manager_ops: {
            time_between_job_cleanup: 1 * 20 * 1000 // 15 minutes
        }
    },
    job_manager: null,
    initialize: function (ops) {
        this.job_manager = new OCS.Classes.DynamicScriptLoaderJobMngr(this.options.job_manager_ops);
        this.setOptions(ops);
    },
    /**
     * Loads a set of scripts dynamically
     *
     * @method load
     * @param load_spec {Object} optional object that can contain the properties complete, script_load, prepend, load, condition, yes, onYes_complete, no, onNo_complete and async
     */
    load: function (load_spec) {
        if (typeof load_spec === "undefined" || load_spec === null || !load_spec) {
            return false;
        } else {
            return this.job_manager.create_job_series(load_spec);
        }
    },
    remove: function (remove_spec) {
        if (Array.isArray(remove_spec)) {
            remove_spec[0].remove_flag = true;
            for (var i = 1; i < remove_spec.length; i++) {
                remove_spec[i].remove_flag = true;
            }
        } else {
            remove_spec.remove_flag = true;
        }
        return this.load(remove_spec);
    },
    /**
     * Method to turn on debugging
     *
     * @method load
     * @param val {Boolean} Whether or not to turn on debugging for existing and newly created jobs
     */
    set_debug: function (val) {
        /* istanbul ignore next */
        if (val) {
            console.log("OCS.DynamicScriptLoader: debug is now active.");
        } else {
            console.log("OCS.DynamicScriptLoader: debug is now inactive.");
        }

        this.job_manager.set_debug(val);
    }
});

OCS.Functions.DynamicScriptLoaderStartup();